import ConfigurationSection from "./ConfigurationSection"

export default function ConfigurationModal({
  clientId,
  onClose,
  mantisBusiness,
}) {
  return (
    <ConfigurationSection
      clientId={clientId}
      onBack={onClose}
      mantisBusiness={mantisBusiness}
    />
  );
} 